import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

function PrivacyMB() {
  return (
    <LegalPageLayout
      titleId="privacy-mb-title"
      icon={faUserShield}
      title="Privacy Policy (Milesoft Books)"
      description={
        <p>Your privacy is our priority. We protect your data with care.</p>
      }
    >
            <p className="effective-date">Effective Date: June 18, 2026</p>
            <p>
              Milesoft Books is a bookkeeping and business management
              application developed and operated by MileSoft. MileSoft is the
              data controller for personal information processed through
              Milesoft Books. For privacy requests, data protection officer
              (DPO) requests, and controller contact purposes, email us at{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              .
            </p>

            <h5>Information We Collect</h5>
            <p>
              Milesoft Books may collect information needed to provide
              bookkeeping, payroll, petty cash, reporting, and account features,
              including:
            </p>
            <ul>
              <li>Name, email address, login information, and user ID</li>
              <li>Business details and account settings</li>
              <li>Financial transactions, chart of accounts, and reports</li>
              <li>Customer, supplier, product, payroll, and petty cash records</li>
              <li>
                Photos and uploaded files, including receipt images, product or
                profile photos, and supporting documents that you choose to add
              </li>
              <li>Subscription or payment status where paid features apply</li>
              <li>
                App activity, Device ID, device type, operating system, app
                version, crash logs, diagnostics, anonymous usage analytics, and
                error logs
              </li>
            </ul>

            <h5>How We Use Information and Legal Basis</h5>
            <p>
              We use information to create and manage accounts, provide
              bookkeeping and reporting features, synchronize business data,
              process subscriptions, provide customer support, improve
              performance, protect against misuse, and comply with legal
              obligations. Our legal basis for processing may include
              performance of a contract or requested service, consent,
              legitimate interests in operating and securing the app, legal
              obligations, and processing requested by you.
            </p>

            <h5>Data Sharing, Sales, and Targeted Advertising</h5>
            <p>
              MileSoft does not sell personal information. We do not share
              personal information with unrelated third parties for their own
              marketing. We may share limited information with trusted service
              providers, including Firebase Authentication, Firestore, cloud
              storage, app diagnostics, payment processors where applicable,
              when required by law, to protect users and systems, or during a
              business transfer.
            </p>
            <p>
              You may opt out of any sale, sharing, or targeted advertising use
              of personal information by emailing{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              . We will honor applicable opt-out rights even though we do not
              sell personal information.
            </p>

            <h5>Security and Encryption</h5>
            <p>
              We use reasonable technical and organizational safeguards,
              including HTTPS and encryption in transit where data is sent to
              our services or service providers, authentication controls, cloud
              security protections, and access controls. No security system is
              completely secure.
            </p>

            <h5>Data Retention</h5>
            <p>
              We retain information while your Milesoft Books account remains
              active or as long as needed to provide the app. After account
              deletion, we delete or anonymize personal information unless
              limited retention is required or permitted for legal compliance,
              security, fraud prevention, dispute resolution, backups,
              subscription management, or accounting records.
            </p>

            <h5>Your Privacy Rights</h5>
            <h6>Right to Know About Data Sharing</h6>
            <p>
              You have the right to ask whether MileSoft shares your personal
              information and, where applicable, the categories of personal
              information shared, the purposes for sharing, and the categories
              of recipients. You may make this request using the contact details
              below.
            </p>
            <p>
              Depending on where you live, including under the GDPR, CCPA/CPRA,
              VCDPA, LGPD, and other applicable privacy laws, you may have the
              right to request access to personal information we collect, request
              correction or rectification of inaccurate information, request
              deletion, request a portable copy, object to or restrict certain
              processing, withdraw consent where processing is based on consent,
              and know whether personal information is sold or shared.
            </p>
            <p>
              California residents may exercise CCPA/CPRA rights to know,
              access, correct, delete, and opt out of sale or sharing. Virginia
              residents may exercise VCDPA rights to access, correct, delete,
              obtain a copy, and opt out of targeted advertising, sale, or
              certain profiling. Users in Brazil may exercise LGPD rights,
              including confirmation, access, correction, anonymization,
              deletion, portability, information about sharing, and consent
              withdrawal. Users in the EEA or UK may exercise GDPR rights,
              including access, rectification, erasure, restriction, objection,
              portability, and the right to lodge a complaint with a supervisory
              authority.
            </p>
            <p>
              To make a privacy rights request, contact{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              .
            </p>

            <h5>Children's Privacy</h5>
            <p>
              Milesoft Books is not intended for children under 13, and we do
              not knowingly collect personal information from children under 13.
            </p>

            <h5>Changes to This Policy</h5>
            <p>
              MileSoft may update this Privacy Policy from time to time. When we
              update it, we will revise the effective date and may notify users
              through the app, email, or another reasonable method.
            </p>

            <h5>Contact Us</h5>
            <p>
              <strong>Company and App Provider:</strong> MileSoft
              <br />
              <strong>App:</strong> Milesoft Books
              <br />
              <strong>Controller and DPO Contact:</strong>{" "}
              <a href="mailto:privacy@milesoft.africa">
                privacy@milesoft.africa
              </a>
              <br />
              <strong>Location:</strong> Malawi
            </p>
    </LegalPageLayout>
  );
}

export default PrivacyMB;
